<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                Neue Liefermahnung
            </modal-header>
            <modal-content>
                <form-input aria-invalid="date" label="Mahnungsdatum" v-model="form.date" :error="form.errors.date" disabled="true" />

                <form-datepicker id="corrected_delivery_date" name="corrected_delivery_date" label="Korrigierter Liefertermin"
                                 v-model:date="form.corrected_delivery_date" :error="form.errors.corrected_delivery_date" />

                <form-text id="comment" label="Kommentar" v-model="form.comment" :error="form.errors.comment" />
                <form-html id="text" label="Nachricht an Produzenten" v-model="form.text" :error="form.errors.text" height="300px" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Absenden</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormText from '@partfactory/Shared/Form/FormText';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormHtml from '@partfactory/Shared/Form/FormHtml';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';

export default {
    name: 'ProducerOrderDeliveryReminderModal',
    components: {
        FormDatepicker,
        FormHtml, FormInput, FormText, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
    },
    emit: ['closeDialog'],
    data() {

        if (this.askForQuote?.producer_order?.producer_user?.language === 2) {
            this.$language.current = 'en';
        }

        const translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
            '<p>leider haben wir bis zum <strong>%{delivery_date}</strong> noch keinen Wareneingang vom Auftrag <strong>%{pfnumber}</strong> feststellen können. Bitte prüfen Sie Ihren Auftragsstatus und geben uns Rückmeldung, bis wann wir mit der Lieferung der Ware rechnen können.</p>'+
            '<p>Sollte die Ware bereits zu uns unterwegs sein, kontaktieren Sie bitte Ihren Versanddienstleister und/oder teilen uns die Daten zur Sendungsverfolgung mit.</p>');

        const text = this.$gettextInterpolate(translated, {
            name: this.askForQuote?.producer_order?.producer_user?.name,
            pfnumber: this.askForQuote.pfnumber,
            delivery_date: this.$moment().format('DD.MM.YYYY'),
        });

        this.$language.current = 'de';

        const form = useForm({
            date: this.$moment().format('DD.MM.YYYY'),
            corrected_delivery_date: null,
            comment: null,
            text: text,
        });
        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.delivery.reminder', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        }
    }
};
</script>
